import Link from "metabase/common/components/Link";
import { LandingButton } from "./components/button/landing_button";
import { LandingFooter } from "./components/footer/landing_footer";
import { FooterGrid } from "./components/footer/footer_grid";
import { CopyrightSection } from "./components/footer/copy_right_section";
import { CircularAvatar } from "./components/circularavatar/circular-avatar";
import MidSection from "./components/mid-section";
import UpperSection from "./components/upper-section";
import LandingHeader from "./components/header";
import insta_icon from "./components/assets/images/instagram.png"
import x_icon from "./components/assets/images/x_pic.png"
import youtube_icon from "./components/assets/images/you_tube.png"
import { RectangualarDotSection } from "./components/rectangular-dot-section";
import rectangular_dots from "./components/assets/images/rectangular_dot.png"
import { InfoSection } from "./components/footer/info-list";



function NewLandingPage() {
    return (
        <div style={{ width: "100%" }}>
            <LandingHeader></LandingHeader>
            <UpperSection></UpperSection>
            <MidSection></MidSection>
            <RectangualarDotSection>
                <img style={{ height: "30px", width: "100%" }} src={rectangular_dots} alt="" />
            </RectangualarDotSection>
            <LandingFooter>
                <FooterGrid>
                    <div>
                        <h1>
                            DAT
                        </h1>
                        <p>
                            Turn data into decisions. <br />
                            Our analytical tools gives you clear insight, <br />
                            interactive dashboards, and powerful reports <br />
                            to help your team grow smarter everyday.
                        </p>
                    </div>

                    <InfoSection>
                        <h3>Contact Us</h3>
                        <ul>
                            <li>0764292299</li>
                            <li>0763292299</li>
                            <li>S.L.P 2833, DODOMA</li>
                            <li>info@ega.go.tz</li>
                            <li>barua@ega.go.tz</li>
                        </ul>

                    </InfoSection>
                    <InfoSection>
                        <h3>Our Services</h3>
                        <ul>
                            <li>Sentimeta Sentimetal</li>
                            <li>Msaada AI</li>
                        </ul>
                    </InfoSection>
                    <InfoSection>
                        <h3>Related Information</h3>
                        <ul>
                            <li>Ubunifu Portal Support Group</li>
                            <li>eMrejesho</li>
                            <li>eMkutano</li>
                            <li>Ubunifu</li>
                            <li>barua@ega.go.tz</li>
                        </ul>
                    </InfoSection>
                </FooterGrid>
                <CopyrightSection>
                    <p>Copyright@eGa-{new Date().getFullYear()}</p>
                    <div style={{ display: "flex", gap: "10px" }}>
                        <a href="https://www.youtube.com/channel/UCqaVDGdr37sctTwNS3Lq_Uw">
                            <CircularAvatar>
                                <img height={30} width={30} src={youtube_icon} alt="" />
                            </CircularAvatar>
                        </a>
                        <a href="https://x.com/ega_tanzania">
                            <CircularAvatar>
                                <img height={30} width={30} src={x_icon} alt="" />
                            </CircularAvatar>
                        </a>
                        <a href="https://www.instagram.com/ega_tanzania/">
                            <CircularAvatar>
                                <img height={30} width={30} src={insta_icon} alt="" />
                            </CircularAvatar>
                        </a>
                    </div>
                </CopyrightSection>
            </LandingFooter>
        </div>
    );
}


export default NewLandingPage;